import { render } from "./ResourceActionButtons.vue?vue&type=template&id=86094354"
import script from "./ResourceActionButtons.vue?vue&type=script&lang=js"
export * from "./ResourceActionButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__